<template>
  <v-container>
    <vue-countdown-timer @start_callback="startCallBack('event started')" @end_callback="endCallBack('event ended')"
      :start-time="sectionStartTime" :end-time="sectionEndTime" :interval="1000" :start-label="'Until start:'"
      :end-label="'Until end:'" label-position="begin" :end-text="'Section ended!'" :day-txt="null" :hour-txt="'hours'"
      :minutes-txt="'minutes'" :seconds-txt="'seconds'"></vue-countdown-timer>

    <v-card>
      <v-container v-if="type == 'Multiple Choices'">
        <v-textarea outlined name="input-7-4" label="Question" value type="number" v-model="question.text">
        </v-textarea>

        <v-img v-if="question.image" :src="'/question/getImage/' + question.image">
        </v-img>

        <v-radio-group v-model="answer.radios" :mandatory="false">
          <v-radio :label="question.optionA" value="A"></v-radio>
          <v-radio :label="question.optionB" value="B"></v-radio>
          <v-radio :label="question.optionC" value="C"></v-radio>
          <v-radio :label="question.optionD" value="D"></v-radio>
        </v-radio-group>

        <div v-if="question.hasTextfield == true">
          <v-textarea outlined name="input-7-4" label="Explanation" v-model="answer.explain">
          </v-textarea>
        </div>

      </v-container>

      <v-container v-else>

        <v-card-text class="text-center">
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel v-for="(item,i) in question.parts.length" :key="i">
              <v-expansion-panel-header>Part {{ item }}</v-expansion-panel-header>
              <v-expansion-panel-content>

                <v-row>
                  <v-col cols="10">

                    <v-textarea outlined name="input-7-4" label="Question" value type="number"
                      v-model="question.parts[i].text" disabled></v-textarea>

                    <v-img v-if="question.parts[i].image" :src="'/question/getImage/' + question.parts[i].image">
                    </v-img>

                    <v-textarea v-if="question.type != 'Multiple Choices'" outlined name="input-7-4" label="Answer"
                      value="true" type="number" v-model="answer.parts[i].text"></v-textarea>

                    <v-file-input v-if="question.parts[i].demandUpload" accept="image/*" label="Upload image"
                      @change="onUpload(i)" v-model="answer.parts[i].fileUploadSlot"></v-file-input>

                    <v-img v-if="answer.parts.length > i && answer.parts[i].image"
                      v-bind:src="'/question/getImage/' + answer.parts[i].image">
                    </v-img>

                  </v-col>

                  <v-col cols="2">

                    <v-text-field disabled label="Part Mark" placeholder="0" v-model="question.parts[i].partScore">
                    </v-text-field>

                  </v-col>
                </v-row>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-card-text>

      </v-container>

    </v-card>
    <v-row>

      <div class="text-center">

        <v-divider class="mx-4" vertical></v-divider>
        <v-btn color="success" v-on:click="saveAnswer()">Save</v-btn>
        <v-divider class="mx-4" vertical></v-divider>
        <v-btn color="success" v-on:click="showNext()">Submit and Show Next</v-btn>

      </div>

    </v-row>

  </v-container>
</template>

<script>
  export default {
    name: "NextQuestion",
    props: ["id"],

    data: () => ({
      panel: [],
      items: 0,
      skill: 50,
      answer: { parts: [] },
      question: { parts: [] },
      length: 1,
      tab: null,
      type: "",
      sectionStartTime: new Date(),
      sectionEndTime: new Date(),
      files: []
    }),

    methods: {
      // Create an array the length of our items
      // with all values as true
      all() {
        this.panel = [...Array(100).keys()].map((k, i) => i);
      },
      // Reset the panel
      none() {
        this.panel = [];
      },
      deleteThis(i) {
        this.questions.splice(i, 1);
        this.items--;
      },
      newQuestion(option) {
        if (option) {
          this.questions.push({});
          this.questions[this.items].type = option;
          this.questions[this.items].score = 0;
          this.panel.push(this.items);
          this.items++;
        }
      },
      totalScore() {
        var totalScore = 0;

        for (var i = 0; i < this.items; i++) {
          totalScore += Number(this.questions[i].score);
        }

        return totalScore;
      },
      async saveAnswer() {

        var response = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/questionOrder/save/" + this.id,
          {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(this.answer)
          }
        );

        if (response.ok) {
          var data = await response.json();
          // console.log(data);

          if (data.error) return alert(data.error);

        } else {
          alert(response.status + ": " + response.statusText);
        }
      },

      async showNext() {
        localStorage.thisQuestion = localStorage.nextQuestion;

        var response = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/questionOrder/getNext/" + this.id,
          {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(this.answer)
          },
        );

        if (response.ok) {
          var data = await response.json();
          console.log(data);

          // alert(JSON.stringify(data));

          if (data.error) return alert(data.error);

          if (data.msg) alert(data.msg);

          if (data.answerSlot && data.answerSlot.question) {
            this.question = data.answerSlot.question;
            this.type = data.answerSlot.type;
            this.sectionStartTime = data.sectionStartTime;
            this.sectionEndTime = data.sectionEndTime;

            if (data.answerSlot.question.parts) {
              this.length = data.answerSlot.question.parts.length;
            }

            // this.answer = { parts: [] };

            if (data.answerSlot.answer) {
              this.answer = data.answerSlot.answer;
            } else {


              if (this.question.parts) {

                this.answer.parts = [];

                for (var i = 0; i < this.question.parts.length; i++) {

                  this.answer.parts.push({});


                }
              }


            }

            console.log(JSON.stringify(this.answer));

          } else {


            // alert("End of exam");

            this.$router.push({ path: `/` });

          }

          this.all();

        } else {
          alert(response.status + ": " + response.statusText);
        }
      },
      startCallBack: function (x) {
        console.log(x);
      },
      endCallBack: function (x) {
        console.log(x);
      },
      // async onClear(i) {
          
      // },
      async onUpload(i) {

        // let index = this.question.versions.indexOf(version);

        if (!this.answer.parts[i].fileUploadSlot) {
          this.answer.parts[i].image = "";
          return;
        }
        
        console.log(" \n\n~~~vi~~~\n\n ");
        console.log(i);
        // console.log(this.files);

        var formData = new FormData()

        if (this.files) {

          console.log("here");

          // formData.append("index", 3);

          // formData.append("index", index);

          formData.append("i", i);
          formData.append("image", this.answer.parts[i].fileUploadSlot);

          var response = await fetch(
            process.env.VUE_APP_API_BASE_URL + "/question/uploadFile/" + this.id,
            {
              method: "PUT",
              credentials: "include",
              headers: {
                // "Content-Type": "application/json"
                // 'Content-Type': 'application/x-www-form-urlencoded',
                // 'Content-Type': 'multipart/form-data'
                'Accept': 'application/json',
              },
              // body: JSON.stringify(this.question)
              body: formData
            });

          if (response.ok) {
            var data = await response.json();
            console.log(data);

            var splits = data[0].fd.split("/");

            var splits2 = splits[splits.length - 1].split(".");

            this.answer.parts[i].image = splits2[0] + "?type=" + splits2[1];

            // alert(this.answer.parts[i].image);

            // if (i != -1) {

            // } else {
            //   this.question.versions[index].image = splits2[0] + "?type=" + splits2[1];

            //   alert(this.question.versions[index].image);
            // }

          } else {
            alert(response.status + ": " + response.statusText);
          }


        }
      }
    },

    watch: {
      length(val) {
        this.tab = val - 1
      },
    },

    async mounted() {

      localStorage.clear();
      localStorage.thisQuestion = {};
      localStorage.nextQuestion = {};

      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/questionOrder/getCurrent/" + this.id,
        {
          method: "GET",
          credentials: 'include',
          // headers: {
          //   "Content-Type": "application/json"
          //   // 'Content-Type': 'application/x-www-form-urlencoded',
          // }
        }
      );

      if (response.ok) {
        var data = await response.json();
        console.log(data);

        // alert(JSON.stringify(data));

        if (data.error) return alert(data.error);

        if (data.msg) alert(data.msg);

        this.question = data.answerSlot.question;
        this.type = data.answerSlot.type;
        this.sectionStartTime = data.sectionStartTime;
        this.sectionEndTime = data.sectionEndTime;

        if (data.answerSlot.answer) {
          this.answer = data.answerSlot.answer;
        } else {

          // alert(JSON.stringify(this.question));

          if (this.question.parts) {

            this.answer.parts = [];

            for (var i; i < this.question.parts.length; i++) {

              this.answer.parts.push({});


            }
          }

        }


        // if (this.answer

        if (data.answerSlot.question.parts) {
          this.length = data.answerSlot.question.parts.length;
          this.all();
        }

      } else {
        alert(response.status + ": " + response.statusText);
      }
    }
  };
</script>